import getColor from "@insite/mobius/utilities/getColor";
import { wishListCardStyles as styles } from "@waytek/Overrides/Components/WishListCard";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.sharingStatus = {
    ...styles.sharingStatus,

    privateTooltip: {
        mergeCss: true,
        cssOverrides: {
            tooltipContainer: css`
                width: 220px;
                position: absolute;
                display: inline-flex;
                justify-content: center;
                bottom: 100%;
                left: 50%;
                margin-left: -80px;
                margin-bottom: 11px;

                &::after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    margin-left: -35px;
                    border-width: 6px;
                    border-style: solid;
                    border-color: ${getColor(colorStrings.commonGlobalWhite)} transparent transparent transparent;
                    margin-top: -1px;
                }

                &::before {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    margin-left: -36px;
                    border-width: 7px;
                    border-style: solid;
                    border-color: ${getColor(colorStrings.commonGlobalLightGray)} transparent transparent transparent;
                    margin-top: -1px;
                }
            `,
        },
    },
};
